// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zJj_Lf69245wSwc6nsjH{padding-top:4px}.Fmgt1ut_yNIrnZFHsPZz{justify-content:center;align-items:center;padding:40px 0;display:flex}.DJRrTEGrxSIJQT5zWvYA{justify-content:center;align-items:center;display:flex}.SwZdCZdj5Ad3A6sypwJC{color:var(--content-primary-tertiary);justify-content:center;align-items:center;padding:20px 0;font-size:12px;font-weight:400;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `zJj_Lf69245wSwc6nsjH`,
	"loading": `Fmgt1ut_yNIrnZFHsPZz`,
	"loadingMore": `DJRrTEGrxSIJQT5zWvYA`,
	"empty": `SwZdCZdj5Ad3A6sypwJC`
};
export default ___CSS_LOADER_EXPORT___;
